import { FormLabel, RequiredIndicator } from "assets/js/Styles";
import FormGenerator from "components/customs/form-generator/input";
import { VIEW_ACTION } from "constants/actions";
import {
  addProjectDropdownStyles,
  addProjectSearchInputStyle,
} from "constants/style";
import React from "react";
import AsyncSelect from "react-select/async";
import { Row, Col } from "reactstrap";
import styled from "styled-components";
import CustomSelect from "components/customs/dropdown";
import CustomDropzone from "views/projects/add/Dropzone";
import { Toast } from "utility/helpers";
import { acceptedExcel, PRINCIPAL_IDS, acceptedFileTypes } from "../constants";

const FormSection = styled.div`
  margin-top: 2rem;
`;

const RowSection = styled(Row)`
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
`;

const StyledDateField = styled(RowSection)`
  .react-datepicker-wrapper {
    width: 100% !important;
  }
`;

const FormColRight = styled.div`
  flex: 0 0 auto;
  width: 100%;

  @media (min-width: 768px) {
    flex: 0 0 auto;
    width: 50%;
  }

  .dropzone-container {
    width: auto;
    height: 65px;
    border: 1px dashed #a3a3a3;

    .upload-files {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  }
`;

const StyledAcceptedFileTypes = styled.p`
  font-size: 12px;
`;

const PhotoSubtitle = styled.p`
  margin: 0;
`;

const UtilizationFormSection = ({
  form,
  setForm,
  action,
  handleCongressmanSearch,
  selectedPrincipal,
  setSelectedPrincipal,
  setDisplayOthersFilter,
  fetchOthers,
  disablePrincipal,
  agencyOptions,
  selectedAgency,
  setSelectedAgency,
  projectOptions,
  selectedProject,
  setSelectedProject,
  displayOthersFilter,
  othersOptions,
  selectedOthers,
  setSelectedOthers,
  setTotalCost,
  totalCost,
  dateImplemented,
  setDateImplemented,
  uploadedExcel,
  setUploadedExcel,
  uploadedFiles,
  setUploadedFiles,
}) => {
  const handleDeleteFile = (file) => {
    const newUploadedFiles = uploadedFiles.filter(
      (files) => files.name !== file
    );
    setUploadedFiles(newUploadedFiles);
  };

  const handleUploadedExcel = (link) => {
    setUploadedExcel((prevUploadedFiles) => {
      const fileIndex = prevUploadedFiles.findIndex(
        (file) => file.name === link.name
      );

      // Update existing file or add new one
      if (fileIndex !== -1) {
        const updatedExcels = [...prevUploadedFiles];
        updatedExcels[fileIndex] = link;

        return updatedExcels;
      }

      if (prevUploadedFiles.length < 5) {
        return [...prevUploadedFiles, link]; // Add the new file
      }

      // Show toast notification if limit is exceeded
      Toast({
        type: 4,
        content: "Exceeded file upload limit of 5",
      });

      return prevUploadedFiles;
    });
  };

  const handleDeleteExcel = (file) => {
    const newUploadedFiles = uploadedExcel.filter(
      (files) => files.name !== file
    );
    setUploadedExcel(newUploadedFiles);
  };

  const handleUploadedFiles = (fileData) => {
    setUploadedFiles((prevUploadedFiles) => {
      const fileIndex = prevUploadedFiles.findIndex(
        (file) => file.name === fileData.name
      );

      // Update existing file or add new one
      if (fileIndex !== -1) {
        const updatedFiles = [...prevUploadedFiles];
        updatedFiles[fileIndex] = fileData;

        return updatedFiles;
      }

      if (prevUploadedFiles.length < 5) {
        return [...prevUploadedFiles, fileData]; // Add the new file
      }

      // Show toast notification if limit is exceeded
      Toast({
        type: 4,
        content: "Exceeded file upload limit of 5",
      });

      return prevUploadedFiles;
    });
  };

  return (
    <FormSection>
      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Event Title"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the event title"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="text"
            placeholder="Event Title"
            value={form.title}
            isDisabled={action === VIEW_ACTION}
            onChange={(event) => {
              const {
                target: { value },
              } = event;

              setForm({
                ...form,
                title: value,
              });
            }}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Venue"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the Venue"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="text"
            placeholder="Venue"
            value={form.venue}
            isDisabled={action === VIEW_ACTION}
            onChange={(event) => {
              const {
                target: { value },
              } = event;

              setForm({
                ...form,
                venue: value,
              });
            }}
          />
        </FormColRight>
      </RowSection>

      <StyledDateField>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Date"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the date of implementation"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="datetime"
            selected={dateImplemented}
            placeholderText="Date"
            dateFormat="MMM-dd-yyyy"
            onChange={(date) => {
              setDateImplemented(date);
            }}
          />
        </FormColRight>
      </StyledDateField>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Principal"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the Principal"}</p>
        </Col>
        <FormColRight>
          <AsyncSelect
            placeholder="Principal"
            loadOptions={handleCongressmanSearch}
            styles={addProjectSearchInputStyle}
            value={selectedPrincipal}
            onChange={(option) => {
              setSelectedPrincipal(option);

              if (PRINCIPAL_IDS.includes(option.id)) {
                setDisplayOthersFilter(true);
                fetchOthers(option.id);
              } else {
                setDisplayOthersFilter(false);
              }
            }}
            isDisabled={disablePrincipal}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Agency"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the Agency"}</p>
        </Col>
        <FormColRight>
          <CustomSelect
            placeholder="Agency"
            styles={addProjectDropdownStyles}
            options={agencyOptions}
            value={selectedAgency}
            onChange={(option) => {
              setSelectedAgency(option);
            }}
            filterOption={(option, searchValue) =>
              option?.label
                ?.toLowerCase()
                ?.includes(searchValue?.toLowerCase()) ||
              option?.data?.acronym
                ?.toLowerCase()
                ?.includes(searchValue?.toLowerCase())
            }
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Program"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the Program"}</p>
        </Col>
        <FormColRight>
          <CustomSelect
            placeholder="Program"
            styles={addProjectDropdownStyles}
            options={projectOptions}
            value={selectedProject}
            onChange={(option) => setSelectedProject(option)}
            isDisabled={selectedAgency === null || selectedAgency?.value === 14}
          />
        </FormColRight>
      </RowSection>

      {displayOthersFilter && (
        <RowSection>
          <Col
            xs="12"
            md="6"
          >
            <FormLabel>{"Others"}</FormLabel>
            <p>{"Provide Other Recipients"}</p>
          </Col>
          <FormColRight>
            <CustomSelect
              placeholder="Others"
              styles={addProjectDropdownStyles}
              options={othersOptions}
              value={selectedOthers}
              onChange={(option) => setSelectedOthers(option)}
            />
          </FormColRight>
        </RowSection>
      )}

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Number of Beneficiaries"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the Number of Beneficiaries"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="number"
            placeholder="Number of Beneficiaries"
            value={form.numberOfBeneficiary}
            isDisabled={action === VIEW_ACTION}
            onValueChange={(value) => {
              const { floatValue } = value;

              const updatedNumberOfBeneficiaries =
                parseInt(floatValue, 10) || 0;

              const updatedTotalCost =
                updatedNumberOfBeneficiaries * form.costPerBeneficiary;

              setForm({
                ...form,
                numberOfBeneficiary: updatedNumberOfBeneficiaries,
              });

              setTotalCost(updatedTotalCost);
            }}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Cost per Beneficiaries"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the Cost per Beneficiaries"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="number"
            placeholder="Cost per Beneficiary"
            value={form.costPerBeneficiary}
            decimalSeparator="."
            thousandSeparator=","
            onValueChange={(value) => {
              const { floatValue } = value;

              const updatedCostPerBeneficiary = floatValue || 0;

              const updatedTotalCost =
                form.numberOfBeneficiary * updatedCostPerBeneficiary;

              setForm({
                ...form,
                costPerBeneficiary: updatedCostPerBeneficiary,
              });

              setTotalCost(updatedTotalCost);
            }}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>{"Total Cost"}</FormLabel>
          <p>{"Provide the Total Cost"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="text"
            placeholder="Total Cost"
            value={totalCost}
            isDisabled
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>{"Remarks"}</FormLabel>
          <p>{"Provide Remarks of the event"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="textarea"
            rows="5"
            placeholder="Remarks"
            value={form.remarks}
            isDisabled={action === VIEW_ACTION}
            onChange={(event) => {
              const {
                target: { value },
              } = event;

              setForm({
                ...form,
                remarks: value,
              });
            }}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>{"Co-Partners"}</FormLabel>
          <p>{"Provide Other Associations of the event"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="text"
            placeholder="Co-Partners"
            value={form.partners}
            isDisabled={action === VIEW_ACTION}
            onChange={(event) => {
              const {
                target: { value },
              } = event;

              setForm({
                ...form,
                partners: value,
              });
            }}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"List of Beneficiaries"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Upload the excel file of List of Beneficiaries"}</p>
        </Col>
        <FormColRight>
          <CustomDropzone
            handleUploadedFiles={handleUploadedExcel}
            handleDeleteFile={handleDeleteExcel}
            uploadedFiles={uploadedExcel}
            label="Upload Excel"
            isDisabled={action === VIEW_ACTION}
            acceptedFileTypes={acceptedExcel}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Facebook Link"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide Facebook Link"}</p>
        </Col>
        <FormColRight>
          <FormGenerator
            type="text"
            placeholder="Facebook Link"
            value={form.fbLinks}
            isDisabled={action === VIEW_ACTION}
            onChange={(event) => {
              const {
                target: { value },
              } = event;

              setForm({
                ...form,
                fbLinks: value,
              });
            }}
          />
        </FormColRight>
      </RowSection>

      <RowSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Photos & Videos"}
            {RequiredIndicator}
          </FormLabel>
          <PhotoSubtitle>
            {"Upload the photos and videos of the event"}
          </PhotoSubtitle>
          <StyledAcceptedFileTypes>
            {"Accepts jpeg/jpg, png, heic, gif, mp4, mpeg, webm, ogg, avi"}
          </StyledAcceptedFileTypes>
        </Col>
        <FormColRight>
          <CustomDropzone
            handleUploadedFiles={handleUploadedFiles}
            handleDeleteFile={handleDeleteFile}
            uploadedFiles={uploadedFiles}
            label="Upload Files"
            isDisabled={action === VIEW_ACTION}
            acceptedFileTypes={acceptedFileTypes}
          />
        </FormColRight>
      </RowSection>
    </FormSection>
  );
};

export default UtilizationFormSection;
